import React, { useEffect } from 'react';
import BliMedlemHeader from '../BliMedlemHeader/BliMedlemHeader';
import { Medlemskapstype } from '../api/medlemskapAPI';
import EnkeltmedlemskapLink from '../MedlemskapType/EnkeltmedlemskapLink';
import MedlemskapLink from '../MedlemskapType/MedlemskapLink';
import { MedlemskapTypeId, sortEnkeltmedlemskap } from '../MedlemskapType/MedlemskapTypeId';
import { ApiResource } from '../api/ApiResource';
import { useErrorPageRedirectIfFailed } from '../hooks';
import loader from '../loading-spinner.module.scss';
import InfoTextBanner from '../InfoTextBanner/InfoTextBanner';
import styles from '../App.module.scss';

function VelgMedlemskapPage(props: { medlemskapstypeListResource: ApiResource<Medlemskapstype[]> }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useErrorPageRedirectIfFailed(props.medlemskapstypeListResource);

    if (props.medlemskapstypeListResource.status !== 'ok') {
        return <div className={loader.loader} />;
    }

    const medlemskapstypeList = props.medlemskapstypeListResource.data;

    const enkeltmedlemskapstypeList = medlemskapstypeList
        .filter((medlemskapstype) => medlemskapstype.id.includes('Enkelt'))
        .sort(sortEnkeltmedlemskap);
    const familiemedlemskapstype = medlemskapstypeList.find(
        (medlemskapstype) => medlemskapstype.id === MedlemskapTypeId.Familie
    )!;
    const medlemskapTypeHusstand = medlemskapstypeList.find(
        (medlemskapstype) => medlemskapstype.id === MedlemskapTypeId.Husstand
    );
    const medlemskapTypeLivsvarig = medlemskapstypeList.find(
        (medlemskapstype) => medlemskapstype.id === MedlemskapTypeId.Livsvarig
    );

    return (
        <div className={styles.pageContainer}>
            <BliMedlemHeader />
            <InfoTextBanner
                startDate={new Date('2024-02-28')}
                endDate={new Date('2024-08-31')}
                content={
                    'Bli medlem nå, og få neste medlemsår på kjøpet. Medlemskapet er da gyldig til 31. august 2025. '
                }
            />
            <EnkeltmedlemskapLink medlemskapstyper={enkeltmedlemskapstypeList} key={'Enkeltmedlemskap'} />
            <MedlemskapLink
                medlemskapstypeId={familiemedlemskapstype.id}
                medlemskapstypePrice={familiemedlemskapstype.price}
                routeToPersonalia={'personalia/Familie'}
                title={familiemedlemskapstype.name}
                description={'Medlemskap for opptil to voksne og et ubestemt antall barn under 26 år i samme husstand.'}
            />
            {medlemskapTypeHusstand && (
                <MedlemskapLink
                    medlemskapstypeId={medlemskapTypeHusstand.id}
                    medlemskapstypePrice={medlemskapTypeHusstand.price}
                    routeToPersonalia={'personalia/Husstand'}
                    title={medlemskapTypeHusstand.name}
                    description={medlemskapTypeHusstand.description}
                />
            )}
            {medlemskapTypeLivsvarig && (
                <MedlemskapLink
                    medlemskapstypeId={medlemskapTypeLivsvarig.id}
                    medlemskapstypePrice={medlemskapTypeLivsvarig.price}
                    routeToPersonalia={'personalia/Livsvarig'}
                    title={medlemskapTypeLivsvarig.name}
                    description={medlemskapTypeLivsvarig.description}
                />
            )}
        </div>
    );
}

export default VelgMedlemskapPage;
